export default __webpack_public_path__ + "static/media/john-desktop.74c35a61.webp";